import { creditsDeduction } from "./firebaseHelpers";

export async function getGeminiTokenUsage({ result, model, userId, websiteId, userMessage, action }) {
  const usage = result?.response?.usageMetadata || {};

  const inputTokens = Number(usage.promptTokenCount || 0);
  const outputTokens = Number(usage.candidatesTokenCount || 0);
  const totalTokens = Number(usage.totalTokenCount || inputTokens + outputTokens);

  await creditsDeduction({ userId, websiteId, userMessage, model, action, inputTokens, outputTokens, totalTokens});

  return {
    inputTokens,
    outputTokens,
    totalTokens,
  };
}